import { IMaintenanceComponent } from 'src/app/maintenance-admin/models/maintenance-component.model';

export const ROOT_MAINTENANCE_COMPONENT: IMaintenanceComponent = {
  id: '1',
  name: 'root',
  condition: '',
  department: { id: '', name: '' },
  sfiCode: '',
  riskLevel: 0,
  mains: '',
  maker: '',
  makerType: '',
  model: '',
  serialNumber: '',
  specification: '',
  located: '',
  classId: '',
  isCriticalComponent: false,
  isClassComponent: false,
  isSpareComponent: false,
  isE0Component: false,
  noxEquipment: false,
  parentComponentId: { id: '', name: '' },
  picturesOfComponent: [],
  schematicImage: undefined,
  jobsCount: 0,
};
